import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import UploadPayslipDocumentRequest, { UploadPayslipDocumentResponse } from "../request/UploadPayslipDocumentRequest";


const UploadPayslipDocumentApiService  = async (request: UploadPayslipDocumentRequest): Promise<UploadPayslipDocumentResponse> => {
  const url = "/document_processing_jobs/";
  const fileData = new FormData();
  // eslint-disable-next-line
  // @ts-ignore
  Object.keys(request).forEach( it => fileData.append(it, request[it]) )
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  }
  const { data } = await axios.post(url, fileData, config);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useUploadPayslipDocumentApiService = () =>
  useMutation<UploadPayslipDocumentResponse, AxiosError, UploadPayslipDocumentRequest>(
    UploadPayslipDocumentApiService, {
      mutationKey: ["UploadPayslipDocumentApiService"]
    }
  );

export default useUploadPayslipDocumentApiService;